<template>
  <div id="prints">
    <h1>{{year}}年{{details.matchName}}比赛</h1>
    <!-- <p class="register_table_title">{{userInfo.schoolName}}报名表</p> -->
    <div style="page-break-after:always">
      <table
        style="table-layout:fixed;word-break: break-all; word-wrap: break-word;width:100%;border:1px solid #999"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <th
            v-for="(item,index) in columns"
            :key="index"
            :style="{borderRight:index + 1 !== columns.length?'1px solid #999':'',width:item.width + 'px'}"
            style="font-size:14px;padding:8px 0;word-break:break-all; word-wrap:break-word;position:relative;"
          >{{item.title}}</th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key=" index">
            <!-- <td>{{index + 1}}</td> -->
            <template v-for="(temp,num) in columns">
              <td
                style="word-break:break-all;"
                :key="num + '_' + index"
                :style="{borderRight:num + 1 !== columns.length?'1px solid #999':'',borderTop:index !== tableData.length?'1px solid #999':''}"
              >{{getKey(temp.key,index)}}</td>
            </template>
          </tr>
        </tbody>
      </table>
      <!-- <div
        v-if="details.state === 0"
        style="width:100%;height:150px;color:#444;padding:20px;border:1px solid #ddd;border-top:none;box-sizing:border-box"
      >
        <section
          style="display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
        >
          <p style="font-size:24px">报名未提交</p>
        </section>
      </div>
      <div
        v-else
        style="width:100%;height:150px;color:#444;padding:10px 20px;border:1px solid #ddd;border-top:none;border-top:none;box-sizing:border-box"
      >
        <p style="font-size:14px;">体育部意见：</p>
        <p
          style="font-size:24px;text-align:center;margin-top:10px;"
        >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
      </div> -->
    </div>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage";
import athletePhotos from "./athletes-photo";
export default {
  components: {
    athletePhotos
  },
  props: ["details", "year", "tableData"],
  data() {
    return {
      columns: [
        // {
        //   title: "序号",
        //   width: 60
        // },
        {
          title: "单位",
          key: "schoolName"
        },
        {
          title: "身份",
          width: 60,
          key: "identity"
        },
        {
          title: "兼任",
          width: 50,
          key: "partTime"
        },
        {
          title: "性别",
          width: 40,
          key: "gender"
        },
        {
          title: "组别",
          width: 40,
          key: "group"
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "姓名全拼",
          key: "pinyin"
        },
        {
          title: "身份证号",
          key: "idCard"
        },
        {
          title: "出生日期",
          key: "birthday"
        },
        {
          title: "注册号码",
          key: "registerNumber"
        },
        {
          title: "比赛号",
          width: 70,
          key: "matchNumber"
        },
        {
          title: "分计单位",
          width: 60,
          key: "subUnit"
        },
        {
          title: "教练",
          key: "coachName",
          width:60
        },
        {
          title: "备注",
          key: "remarks",
          width:50
        },
        {
          title: "距离",
          width: 50,
          key: "distance"
        },
        {
          title: "泳式",
          width: 50,
          key: "swimmingStyle"
        },
        {
          title: "报名成绩",
          width: 60,
          key: "score"
        },
        {
          title: "测验",
          width: 40,
          key: "test"
        },
        {
          title: "特殊标记",
          width: 60,
          key: "mark"
        }
      ],
      userInfo: JSON.parse(getSession("userInfo")) || "",
      athleteList: {}
    };
  },
  computed: {
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key && item.key !== "identity") {
            keys = this.tableData[index][item.key];
          } else if (item.key === key && item.key === "identity") {
            switch (this.tableData[index][item.key]) {
              case 1: {
                keys = "运动员";
                break;
              }
              case 2: {
                keys = "教练";
                break;
              }
              case 3: {
                keys = "领队";
                break;
              }
              case 4: {
                keys = "工作人员";
                break;
              }
              case 5: {
                keys = "医生";
                break;
              }
              default: {
                keys = "代表队";
                break;
              }
            }
          }
        });

        return keys;
      };
    }
  },
  methods: {
    print() {
      this.isShowBottom = false;
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .print_box_border {border:1px solid #999;border-top:none;border-bottom:none} .margin_top {margin-top:20mm!important} .top_border {border-top:1px solid #999!important} .left_border {border-left:1px solid #999!important} .bottom_border {border-bottom:1px solid #999!important} .right_border {border-right:1px solid #999!important;} .athletes_photos {margin-top:15mm!important;border:none!important} .headers{margin-top:5mm!important;padding-top:0!important;border-bottom:none!important} .fonts_color {color:#000} .athlete_info {font-size:16px!important;margin-bottom:6px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:20px;color:#000} table tr td {padding:8px 0!important;font-size:12px;text-align:center} main {margin:15mm 0} h1 { margin:5mm 0 10px 0;padding-top:10px;font-size:24px;text-align:center } span.rights {width:560px}'+ 
          '.register_table_title {margin:0;padding:0;font-size:16px;color:#000}' + 
          '</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
</style>